import { lazy } from 'react';
import ProtectedRoute from '@/components/ProtectedRoute';

const Hub = lazy(() => import('./Hub'));
const Licencas = lazy(() => import('./Licencas'));
const Solicitacoes = lazy(() => import('./Solicitacoes'));
const SolicitacaoForm = lazy(() => import('./SolicitacaoForm'));
const Configuracoes = lazy(() => import('./Configuracoes'));
const Leads = lazy(() => import('./Leads'));
const LeadsCorretor = lazy(() => import('./LeadsCorretor'));
const LeadsMovimentacoes = lazy(() => import('./LeadsMovimentacoes'));

const DO_FLUXO = ['salesforce.solicitar', 'salesforce.aprovar', 'salesforce.ti.manage', 'salesforce.view'];

export const salesforceRoutes = [
    {
        path: '/salesforce',
        element: (
            <ProtectedRoute anyOf={DO_FLUXO}>
                <Hub />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/licencas',
        element: (
            <ProtectedRoute permission="salesforce.view">
                <Licencas />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/solicitacoes',
        element: (
            <ProtectedRoute anyOf={DO_FLUXO}>
                <Solicitacoes />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/solicitacoes/nova',
        element: (
            <ProtectedRoute permission="salesforce.solicitar">
                <SolicitacaoForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/leads',
        element: (
            <ProtectedRoute permission="salesforce.view">
                <Leads />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/leads/movimentacoes',
        element: (
            <ProtectedRoute permission="salesforce.view">
                <LeadsMovimentacoes />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/leads/:dono',
        element: (
            <ProtectedRoute permission="salesforce.view">
                <LeadsCorretor />
            </ProtectedRoute>
        ),
    },
    {
        path: '/salesforce/configuracoes',
        element: (
            <ProtectedRoute permission="salesforce.config.manage">
                <Configuracoes />
            </ProtectedRoute>
        ),
    },
];
